import {
    apiRequest,
    penataranCreate
} from "../../../../../services/adapters/kepegawaian/penataranService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", penataranCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository